module.exports = __webpack_public_path__ + "img/img_userCase_calling.b3d38ab5.svg";